import { createWebHistory, createRouter } from "vue-router";
import listaProdutos from "../pages/ListaProdutos/listaProdutos.vue";
import finalizaCompra from "../pages/FinalizaCompra/finalizaCompra.vue";
import contatosEmpresa from "../pages/ContatosEmpresa/contatosEmpresa.vue";
import loginUser from "../pages/usuario/login.vue";
import meusDadosPedidos from "../pages/usuario/meusDadosPedidos.vue";
import meusDados from "../pages/usuario/meusDados.vue";
import meusPedidos from "../pages/usuario/meusPedidos.vue";
import metaTags from "../pages/metatags/metaTags.vue";


const routes = [
  {
    path: "/",
    name: "listaProdutos",
    component: listaProdutos,
    props: true,
  },
  {
    path: "/metatags",
    name: "metatags",
    component: metaTags,
    props: true,
  },
  {
    path: "/finalizacompra",
    name: "FinalizaCompra",
    component: finalizaCompra,
    props: true,
  },
  {
    path: "/contatos",
    name: "contatosEmpresa",
    component: contatosEmpresa,
    props: true,
  },
  {
    path: "/meusDados",
    name: "meusDados",
    component: meusDadosPedidos,
    props: true,
    children: [
      {
        path: "pedidos",
        component: meusPedidos,
        name: "dadosCadTele",
        props: true,
      },
      {
        path: "usuario",
        component: meusDados,
        name: "dadosCadEmpresa",
        props: true,
      },
    ],
  },
  {
    path: "/login",
    name: "login",
    component: loginUser,
    props: true,
  },
  {
    path: "/registro",
    name: "registro",
    component: loginUser,
    props: true,
  },
  {
    path: "/:catchAll(.*)", // This matches any path that hasn't been matched yet
    redirect: "/", // Redirect to the root path
  },
];
const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
